<template>
  <Headers :type="prop.type" :countDown="prop.countDown"> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <!-- <p class="cardName">{{ prop.cardName }}</p> -->
    <Form
      @submit="onSubmit"
      :validation-schema="schema"
      @invalid-submit="onInvalidSubmit"
    >
      <div :class="[deviceType, 'inner']">
        <div :class="[deviceType, 'content']">
          <div class="content2">
            <div class="summary">
              <div class="terms-and-conditions">
                {{ t("ccOnBoarding.termsCondition.header") }}
              </div>
            </div>
            <div class="frame-1171275332">
              <div class="consent">
                <div class="agree">
                  <CheckBoxValid
                    id="agree"
                    class="checkbox"
                    :required="false"
                    field="ampConsent"
                    @selected="handleCCConsent"
                    :selected-value="prop.ccForm.declaration.declaration"
                    :nomsg="true"
                  >
                    <template v-slot:label>
                      <div :class="[deviceType, 'termsContainer']">
                        <p class="checkbox-label2">
                          {{ t("ccOnBoarding.termsCondition.content1-1") }}
                        </p>
                        <br />
                        <p class="checkbox-label2">
                          {{ t("ccOnBoarding.termsCondition.content1-2") }}
                        </p>
                      </div>
                    </template>
                  </CheckBoxValid>
                </div>
              </div>
            </div>

            <div class="frame-1171275332">
              <div class="consent">
                <div class="agree">
                  <CheckBoxValid
                    id="agree"
                    class="checkbox"
                    :required="false"
                    field="ampConsent2"
                    @selected="handleCCConsent2"
                    :selected-value="prop.ccForm.declaration.declaration2"
                    :nomsg="true"
                  >
                    <template v-slot:label>
                      <p class="checkbox-label2">
                        {{ t("ccOnBoarding.termsCondition.content2") }}
                        <a
                          class="termOfService"
                          :href="aeoncredit"
                          target="_blank"
                        >
                          {{ aeoncredittext }}</a
                        >
                        {{ t("ccOnBoarding.termsCondition.content4") }}
                      </p>
                    </template>
                  </CheckBoxValid>
                </div>
              </div>
            </div>

            <div class="frame-1171275332">
              <div class="consent">
                <div class="agree">
                  <CheckBoxValid
                    id="agree"
                    class="checkbox"
                    :required="false"
                    field="ampConsent3"
                    @selected="handleCCConsent3"
                    :selected-value="prop.ccForm.declaration.declaration3"
                    :nomsg="true"
                  >
                    <template v-slot:label>
                      <p class="checkbox-label2">
                        {{ t("ccOnBoarding.termsCondition.content5") }}
                        <a
                          class="termOfService"
                          :href="aeoncredit"
                          target="_blank"
                        >
                          {{ aeoncredittext }}</a
                        >
                        {{ t("ccOnBoarding.termsCondition.content6") }}
                      </p>
                    </template>
                  </CheckBoxValid>
                </div>
              </div>
            </div>

            <div class="frame-1171275332">
              <div class="consent">
                <p class="checkbox-label2">
                  {{ t("ccOnBoarding.termsCondition.content7") }}
                </p>
                <br />
                <div class="agree">
                  <!-- <CheckBoxValid
                    id="agree"
                    class="checkbox"
                    :required="false"
                    field="ampConsent4"
                    @selected="handleCCConsent4"
                    :selected-value="prop.ccForm.declaration.declaration4"
                    :nomsg="true"
                  >
                    <template v-slot:label>
                      <p class="checkbox-label2">
                        {{ t("ccOnBoarding.termsCondition.content7") }}
                      </p>
                    </template>
                  </CheckBoxValid> -->
                  <NewCheckBoxYesNo
                    v-for="option in yesNoTrueFalse"
                    :key="option.value"
                    :label="option.label"
                    :values="option.value"
                    :label-class="'radioLabel'"
                    id="agree"
                    class="radioHorizontal"
                    :class="{ 'display-flex': true }"
                    :required="false"
                    field="ampConsent4"
                    @selected="handleCCConsent4"
                    :selected-value="prop.ccForm.declaration.declaration4"
                    :nomsg="true"
                  >
                  </NewCheckBoxYesNo>
                </div>
              </div>
            </div>
            <div class="frame-1171275332">
              <div class="consent">
                <!-- <div class="agree"> -->

                <CheckBoxValid
                  id="agree"
                  class="checkbox"
                  :required="false"
                  field="ampConsent5"
                  @selected="handleCCConsent5"
                  :selected-value="prop.ccForm.declaration.declaration5"
                  :nomsg="true"
                >
                  <template v-slot:label>
                    <div :class="[deviceType, 'termsContainer']">
                      <p class="checkbox-label2">
                        {{ t("ccOnBoarding.termsCondition.content2-1") }}
                      </p>
                      <br />
                      <p class="checkbox-label2">
                        {{ t("ccOnBoarding.termsCondition.content2-2") }}
                        <a
                          class="termOfService"
                          :href="aeoneinvoice"
                          target="_blank"
                        >
                          {{ t("ccOnBoarding.termsCondition.content2-3") }}</a
                        >.
                      </p>
                      <br />
                      <p class="checkbox-label2">
                        {{ t("ccOnBoarding.termsCondition.content2-4") }}
                        <a
                          class="termOfService"
                          :href="aeoncredit"
                          target="_blank"
                        >
                          {{ t("ccOnBoarding.termsCondition.content2-5") }}</a
                        >.
                      </p>
                      <br />
                      <p class="checkbox-label2">
                        {{ t("ccOnBoarding.termsCondition.content2-6") }}
                        <a
                          class="termOfService"
                          :href="aeoncredit"
                          target="_blank"
                        >
                          {{ t("ccOnBoarding.termsCondition.content2-5") }}</a
                        >{{ t("ccOnBoarding.termsCondition.content2-7") }}
                      </p>
                    </div>
                  </template>
                </CheckBoxValid>
                <br />
                <InputText
                  v-if="prop.ccForm.declaration.declaration5 == 'true'"
                  class="inputcomponent"
                  v-model="prop.ccForm.declaration.taxpayer"
                  field="taxpayer"
                  :required="false"
                  :placeholder="t('ccOnBoarding.termsCondition.taxpayer')"
                  :max-length="14"
                  :autocomplete="'new-password'"
                  @keydown="handleKeyDown"
                  @keydown.enter.prevent="handleEnterKey"
                />
              </div>
            </div>
            <div class="frame-1171275332">
              <div class="consent">
                <div class="agree">
                  <CheckBoxValid
                    id="agree"
                    class="checkbox"
                    :required="false"
                    field="ampConsent6"
                    :nomsg="true"
                    :disabled="true"
                    :hidden="true"
                  >
                    <template v-slot:label>
                      <p class="checkbox-label2">
                        {{ t("ccOnBoarding.termsCondition.content8") }}
                      </p>
                    </template>
                  </CheckBoxValid>
                </div>
              </div>
            </div>
          </div>
          <div :class="[deviceType, 'buttoncontainer']">
            <button
              :class="[deviceType, 'left-button']"
              type="button"
              @click="handleBack"
            >
              {{ t("ccOnBoarding.back") }}
            </button>
            <button
              :class="[deviceType, 'right-button']"
              :disabled="isBtnDisabled"
            >
              {{ t("ccOnBoarding.termsCondition.submit") }}
            </button>
          </div>
        </div>
      </div>
    </Form>
    <div v-if="prop.overlay" class="overlay">
      <div class="text-center flex-container">
        <p class="loading">
          <b>{{ t("ccOnBoarding.uploadDocument.loading") }}</b>
          <!-- <b>Submit Fail</b> -->
        </p>
        <br />
        <div class="spinner-border" role="status">
          <span class="sr-only">{{
            t("ccOnBoarding.uploadDocument.loading2")
          }}</span>
        </div>
        <br />
        <br />
        <p class="loading">
          <b>{{ t("ccOnBoarding.uploadDocument.loading2") }}</b>
        </p>
        <br />
        <br />
      </div>
    </div>
    <PopupMessage
      name="'none'"
      :type="'none'"
      :header="'termsAndCondition'"
      v-if="prop.termsSubmitFail"
      @close-modal="closeTNCModal"
      @submit="submitTNCModal"
      :popup="true"
    >
    </PopupMessage>
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  computed,
  onMounted,
  onBeforeMount,
  type PropType,
  watch,
} from "vue";
import Headers from "./components/Headers.vue";
import i18n from "@/plugin/i18n";
import { Form } from "vee-validate";
import type FormCC from "@/interface/FormCC";
import Constants from "@/constants/constants";
import CheckBoxValid from "./components/NewCheckBox.vue";
import PopupMessage from "./components/PopupMessage.vue";
import { deviceDetect } from "mobile-device-detect";
import NewCheckBoxYesNo from "./components/NewCheckBoxYesNo.vue";
import hrcQuestionnaireEnum from "@/enum/HRCQuestionnaireEnum";
import yesNoTrueFalse from "@/enum/YesNoTrueFalseEnum";
import InputText from "./components/NewInputTextComponent.vue";

const deviceType = ref("");

onMounted(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
});

onBeforeMount(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
});

const prop = defineProps({
  ccForm: {
    type: Object as PropType<FormCC>,
    required: true,
  },
  termsSubmitFail: {
    type: Boolean,
  },
  overlay: {
    type: Boolean,
  },
  cardName: {
    type: String,
    required: true,
  },
  type: {
    type: String,
  },
  countDown: {
    type: String,
  },
  isAutoPopulate: {
    type: Boolean,
    default: false,
  },
  populatedIdInfo: {
    type: Object,
    required: true,
  },
});

const aeoncredit = Constants.AEON_CREDIT;
const aeoncredittext = Constants.AEON_CREDIT_TEXT;
const aeoneinvoice = Constants.AEON_E_INVOICE;

const { t } = i18n.global;

const handleCCConsent = (value: string) => {
  if (value) prop.ccForm.declaration.declaration = value;
  else prop.ccForm.declaration.declaration = "";
};

const handleCCConsent2 = (value: string) => {
  if (value) prop.ccForm.declaration.declaration2 = value;
  else prop.ccForm.declaration.declaration2 = "";
};
const handleCCConsent3 = (value: string) => {
  if (value) prop.ccForm.declaration.declaration3 = value;
  else prop.ccForm.declaration.declaration3 = "";
};
const handleCCConsent4 = (value: string) => {
  prop.ccForm.declaration.declaration4 = value;
};
const handleCCConsent5 = (value: string) => {
  if (value) prop.ccForm.declaration.declaration5 = value;
  else prop.ccForm.declaration.declaration5 = "";
};

const isBtnDisabled = computed(() => {
  return (
    prop.ccForm.declaration.declaration !== "true" ||
    prop.ccForm.declaration.declaration2 !== "true" ||
    prop.ccForm.declaration.declaration3 !== "true" ||
    prop.ccForm.declaration.declaration4 == "" ||
    (prop.ccForm.declaration.declaration5 == "true" &&
      prop.ccForm.declaration.taxpayer == "")
  );
});

const schema = computed(() => {
  return {
    taxpayer:
      prop.ccForm.declaration.declaration5 == "true"
        ? "required|minLengthNumber:11"
        : "",
  };
});

watch(
  () => prop.ccForm.declaration.declaration5,
  (newValue) => {
    if (!newValue) {
      prop.populatedIdInfo.terms.taxIdentificationNo =
        prop.ccForm.declaration.taxpayer;
      prop.ccForm.declaration.taxpayer = "";
    } else {
      prop.ccForm.declaration.taxpayer =
        prop.populatedIdInfo.terms.taxIdentificationNo;
    }
  },
);

const onInvalidSubmit = () => {};

const emit = defineEmits([
  "previousStep",
  "submit",
  "jumpStep",
  "close",
  "getProductStep",
]);

const closeTNCModal = () => {
  emit("close");
};

const submitTNCModal = () => {
  emit("submit");
  emit("close");
};

const onSubmit = () => {
  if (
    prop.ccForm.declaration.declaration == "" ||
    prop.ccForm.declaration.declaration2 == "" ||
    prop.ccForm.declaration.declaration3 == "" ||
    prop.ccForm.declaration.declaration4 == "" ||
    (prop.ccForm.declaration.declaration5 == "true" &&
      prop.ccForm.declaration.taxpayer == "")
  )
    return;
  emit("submit");
};

const handleBack = () => {
  if (prop.type == "PF_CC" || prop.type == "EP_CC") {
    //TODO-Matrix
    emit("getProductStep", false, true, false, false, "");
  } else {
    emit("previousStep");
  }
};

const handleKeyDown = (event: KeyboardEvent) => {
  const isDigit = /^[0-9]$/.test(event.key);
  const isArrowKey = /^Arrow(Left|Right)$/.test(event.key);

  const isIOSArrowKey =
    event.key === "UIKeyInputLeftArrow" || event.key === "UIKeyInputRightArrow";
  const isAndroidArrowKey =
    event.key === "ArrowLeft" || event.key === "ArrowRight";

  const isDeleteKey = event.key === "Delete";
  const isBackspace = event.key === "Backspace";
  const isTabKey = event.key === " Tab";

  const isSymbol = /[^a-zA-Z0-9]/.test(event.key); // true for symbol input

  if (
    isSymbol &&
    !isBackspace &&
    !(isArrowKey || isIOSArrowKey || isAndroidArrowKey) &&
    !isDeleteKey &&
    !isTabKey
  ) {
    event.preventDefault();
  }
};

const handleEnterKey = () => {};
</script>

<style scoped>
.progressContainer {
  max-width: 1440px;
  margin: auto;
  padding: 4% 8%;
  background: #fff;
}

.right-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.left-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;

  flex: 0 0 25%;
}

.right-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}
.line {
  border-bottom: 1px solid #e4e4e4;
}

.buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
}

/* .left-button {
  flex: 0 0 15%;
} */

.agree {
  display: flex;
  align-items: flex-start;
}

.checkbox {
  color: rgba(0, 0, 0, 0.54);
  font-size: 14px;
  font-family: Outfit;
  font-weight: 500;
  line-height: 18.2px;
  word-wrap: break-word;
}

.checkbox-label2 {
  position: relative;
  align-items: center;
  color: var(--black-medium-54, rgba(0, 0, 0, 0.54));
  font-family: Outfit;
  font-size: 14px;
  font-weight: 500;
  line-height: 130%;
  margin-left: 8px;
  margin-bottom: 0px;
}

/* .checkbox-label2.taxpayer {
  margin-bottom: 30px;
} */

.termOfService {
  background: none !important;
  border: none;
  color: #ac2887;
  font-size: 14px;
  font-family: Outfit;
  font-weight: 500;
  line-height: 18.2px;
  word-wrap: break-word;
  cursor: pointer;
  text-decoration: none;
}

.summary,
.summary * {
  box-sizing: border-box;
}
.summary {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
  margin-bottom: 24px;
}
.terms-and-conditions {
  color: #111111;
  text-align: left;
  font-family: var(--custom-3-font-family, "Outfit", sans-serif);
  font-size: var(--custom-3-font-size, 24px);
  line-height: var(--custom-3-line-height, 130%);
  font-weight: var(--custom-3-font-weight, 500);
  position: relative;
}

.content {
  padding: 0 8%;
}

.frame-1171275332,
.frame-1171275332 * {
  box-sizing: border-box;
}
.frame-1171275332 {
  border-radius: 16px;
  border-style: solid;
  border-color: var(--line-break, #e4e4e4);
  border-width: 2px;
  padding: 16px 24px 16px 24px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
  margin-bottom: 24px;
}
.consent {
  color: var(--web-black-medium, #757575);
  text-align: left;
  font-family: var(--subtitle-2-font-family, "Outfit", sans-serif);
  font-size: var(--subtitle-2-font-size, 14px);
  line-height: var(--subtitle-2-line-height, 130%);
  font-weight: var(--subtitle-2-font-weight, 500);
  position: relative;
  flex: 1;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}

.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}

.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}

.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

.cardName {
  color: rgba(0, 0, 0, 0.38);
  font: 500 16px/130% "Outfit";
  margin-bottom: 10px;
  margin-top: 5px;
  text-align: left;
  position: relative;
  align-self: stretch;
}

.radioHorizontal {
  margin-right: 24px !important;
  color: rgba(0, 0, 0, 0.38);
  margin-bottom: 5px;
}

@media (max-width: 700px) {
  .buttoncontainer {
    gap: 10px;
  }

  .left-button {
    flex: 0 0 30%;
  }

  .right-button {
    flex: 0 0 68%;
  }

  .right-button:disabled {
    flex: 0 0 68%;
  }
  .container {
    flex-direction: column;
  }
  .flex_half {
    width: 100%;
  }
}

.content2 {
  border-bottom: 1px solid #e4e4e4;
}

.content:is(.Mobile) {
  padding: 0;
}

.progressContainer:is(.Mobile) {
  max-width: 1440px;
  margin: auto;
  padding: 0;
  background: #fff;
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.buttoncontainer:is(.Mobile) {
  gap: 10px;
  margin-bottom: 24px;
}

.left-button:is(.Mobile) {
  flex: 0 0 30%;
}

.right-button:is(.Mobile) {
  flex: 0 0 68%;
}

.termsContainer:is(.Mobile) {
  height: 257px;
  overflow: auto;
  padding-right: 20px;
}

.termsContainer::-webkit-scrollbar-thumb {
  background-color: #ac2887;
  border-radius: 24px;
}

.termsContainer::-webkit-scrollbar-track {
  background-color: #e4e4e4;
  border-radius: 24px;
}

.termsContainer::-webkit-scrollbar {
  width: 8px;
}

/* Firefox */
@-moz-document url-prefix() {
  .termsContainer {
    scrollbar-width: thin; /* Customizes scrollbar width */
    scrollbar-color: #ac2887 #e4e4e4; /* Customizes thumb and track color */
  }
}
</style>
